<template>
  <div>
    <index-card :loading="loading.trucks">
      <template slot="header">
        <div class="d-flex align-center">
          <v-btn text icon large to="/" exact><v-icon class="white--text">mdi-arrow-left</v-icon></v-btn>
          <v-btn color="white" class="blue-grey--text elavation-0 font-weight-bold my-1 mx-1" @click="$router.push({name: 'CreateTruck'})" center>
            <v-icon small left>mdi-plus</v-icon>Adicionar Veículo
          </v-btn>
        </div>
        <div class="d-flex align-center headline white--text">
          Veículos
          <v-btn text icon @click="getData()" exact><v-icon class="white--text">mdi-refresh</v-icon></v-btn>
        </div>
      </template>

      <template slot="subheader">
        <div class="trucks-list-filters">
          <filter-data
            :with_client="false"
            :with_date_start="false"
            :with_date_end="false"
            with_text_search
            text_search_label="Pesquisar"
            :extra-filters-count="1"
            :loading_block="loading.trucks"
            @doneFilter="handleDoneFilter"
          >
            <template v-slot:extra-filters>
              <v-col cols="12" md="6">
                <v-select
                  v-model="selected_filter"
                  :items="filters"
                  item-value="value"
                  item-text="name"
                  outlined
                  dense
                  hide-details="auto"
                  prepend-inner-icon="mdi-truck-outline"
                  label="Tipo"
                />
              </v-col>
            </template>
          </filter-data>
        </div>
      </template>
      
      <template slot="data_table">
        <v-card v-if="!this.loading.trucks" text color="white elevation-3 rounded-0"></v-card>
        <v-data-table v-if="!this.loading.trucks" @click:row="handleEditItem" :headers="headers" :items="trucks"  
          class="elevation-3" :search="search" mobile-breakpoint="1">
          <template v-slot:no-results>
            <v-alert  :value="true" type="error" icon="mdi-alert">
              Não foi possível encontrar "{{ search }}" em veículos.
            </v-alert>
          </template>
        </v-data-table>
      </template>
    </index-card>
  </div>
</template>

<script>
import Api from '@/api/index';
import { mapState } from 'vuex';

export default {
  name: 'TrucksList',
  components: {
    EditTruck: ()=> import('./EditTruck.vue'),
    IndexCard: () => import("@/_backoffice/_registrations/components/shared/index/IndexCard.vue"),
    FilterData: () => import('@/components/shared/FilterData.vue'),
  },
  data() {
    return {
      search: '',
      applied_filter: {},
      headers: [
        { text: 'Placa', value: 'attributes.plate', align: 'center' },
        { text: 'Chassi', value: 'attributes.chassi', align: 'center' },
        { text: 'Modelo', value: 'attributes.model', align: 'center' },
        { text: 'Marca', value: 'attributes.manufacturer', align: 'center' },
      ],
      filters:[
        {name:"Todos", value: {}},
        {name:"Internos", value: {internal: true}},
        {name:"Externos", value: {internal: false}},
      ],
      selected_filter: {},
      trucks: [],
      loading:{
        trucks: false
      },
    }
  },
  methods: {
    getData(){
      this.getTrucks()
    },
    handleDoneFilter(filter = {}) {
      this.search = filter.query ? String(filter.query) : ''
      this.applied_filter = { ...this.selected_filter }
      this.getTrucks()
    },
    getTrucks(){
      if(this.activeModalityId){
        let filter = {...this.applied_filter, modality_ids:[this.activeModalityId]}
        this.loading.trucks = true
        Api.Truck.index(filter).then(req => req.data).then(res => {
          this.trucks = [...res.data]
        }).finally(()=>{
          this.loading.trucks = false
        })
      }
    },
    handleEditItem(item){
      this.$router.push({name:"ShowTruck", params:{id: item.id}})
    },
  },
}
</script>

<style scoped>
.trucks-list-filters {
  width: 100%;
  flex: 1 1 100%;
  min-width: 0;
}
.trucks-list-filters >>> .filter-data-card {
  width: 100%;
}
</style>